import { Space } from "antd";
import { SpaceProps } from "./type";

function AntSpace(props: SpaceProps) {
  return <Space {...props} />;
}

export { AntSpace as Space };
